import { MDBIcon } from 'mdbreact';
import React, { Component } from 'react';
import { URLImgFront } from '../../config/URLDB';

class Seccion1 extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    render() {
        return (
            <React.Fragment>
                <div className="diseño_responsive_view" style={{ width: '100%', paddingTop: '120px' }}>
                    <img style={{ width: '100%', height: '90vh', objectFit: 'cover' }} className="img-fluid" src={`${URLImgFront}/assets/img_principal/PortadaBeneficios.webp`} alt="PORTADA BENEFICIOS" />
                    <span className="py-2 pl-4 d-flex flex-wrap align-items-center" style={{ fontSize: '20px', backgroundColor: '#F3F3F3' }}><MDBIcon icon="caret-right" className="ml-2 mr-1" /> Beneficios</span>
                    <div className="vista_p_ahorro_credito" style={{ position: 'absolute', bottom: '180px', right: '100px', textAlign: 'right' }}>
                        <p className="my-0" style={{ fontSize: '50px', color: '#FFF' }}>Conoce todos los <span style={{ fontWeight: 'bold' }}>beneficios</span></p>
                        <p className="my-0" style={{ fontSize: '50px', color: '#FFF' }}>que tienes por ser asociado</p>
                        <p className="pb-5" style={{ fontSize: '50px', color: '#FFF' }}>de <span style={{ fontWeight: 'bold' }}>UTRAHUILCA</span>.</p>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Seccion1;